<script>
    export let text
    export let clickable = false
    export let classes = ''
</script>

<style>
    .tag-item {
        display: inline-block;
        border-radius: 12px;
        padding: 1px 8px 1px;
        margin: 0 1px 2px 0;
        /* background-color: #6f899c; */
        background-color: #c6e7ff;
        color: #376979;
        font-size: 12px;
        line-height: 14px;
    }
    .tag-item.clickable:hover {
        background-color: #ff7675;
        color: #fff;
    }
    .tag-item.completed {
        background-color: #31c7aa;
        color: #fff;
    }
</style>

{#if clickable}
    <div class="tag-item avoid-selection {classes}" class:clickable on:click|stopPropagation>{text}</div>
{:else}
    <div class="tag-item avoid-selection {classes}">{text}</div> 
{/if}
